import { combineReducers } from "@reduxjs/toolkit";
import partnerReducer from "./Partner/partnerDataSlice";
import siteDataReducer from "./Partner/siteData";
import partnerSettingsReducer from "./Partner/partnerSettings";
import modalReducer from "./Partner/modalSlice";

const rootReducer = combineReducers({
  partner: partnerReducer,
  siteData: siteDataReducer,
  partnerSettings: partnerSettingsReducer,
  modal: modalReducer,
});

export default rootReducer;
